import { FAQPage, WithContext } from 'schema-dts';
import { TransformedModule } from '~/transforms/transformModules';

/**
 * Generates FAQPage JSON-LD schema from a list of all modules on a given page
 */
export function generateFAQSchema(modules: TransformedModule[]): WithContext<FAQPage> | {} {
  const questionWithAnswers: { question: string; answer: string }[] = modules
    .filter(module => module.type === 'cm-accordion')
    .map(module =>
      (module.data.collapsibles ?? []).map((item: { headline: string | undefined; content: string | undefined }) => ({
        question: typeof item.headline || '',
        answer: typeof item.content === 'string' ? item.content : '',
      }))
    )
    .flat();

  if (!questionWithAnswers.length) {
    return {};
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity:
      questionWithAnswers.map(entry => ({
        '@type': 'Question',
        name: entry.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: entry.answer,
        },
      })) || [],
  };
}
